import ApiService from '../services/api';

export type MaintenanceTableMetricSource = 'asset' | 'manual' | 'revision';

export interface MaintenanceTableMetric {
    value?: number;
    occurredAt?: string;
    source?: MaintenanceTableMetricSource;
}

export interface MaintenanceTableItem {
    id?: string;
    assetId?: string;
    vehicleName?: string;
    chassis?: string;
    electedMetrics?: {
        odometer?: MaintenanceTableMetric;
        hourMeter?: MaintenanceTableMetric;
    };
    licensePlate?: string;
    accountName?: string;
    fieldCampaignAmount?: number;
    maintenanceGroup?: string;
    warrantyStatus?: string;
    hasDeviceConnection?: boolean;
    connectivity?: string;
    volkstotal?: string;
    truckerPay?: string;
    volksEssentialsPlanContract?: string;
    lastMaintenance?: {
        number?: number;
        checkupType?: string;
        maintenanceDate?: string;
    };
    nextMaintenance?: {
        number?: number;
        kmToNextMaintenance?: number;
        maintenanceStatus?: string;
    };
}

const extractList = (data: unknown): MaintenanceTableItem[] => {
    if (Array.isArray(data)) {
        return data;
    }
    if (data && typeof data === 'object') {
        const record = data as Record<string, unknown>;
        for (const key of ['list', 'assets', 'data', 'items', 'result']) {
            if (Array.isArray(record[key])) {
                return record[key] as MaintenanceTableItem[];
            }
        }
    }
    return [];
};

export const fetchMaintenanceTable = async (assetIds: string[]): Promise<MaintenanceTableItem[]> => {
    if (!assetIds.length) {
        return [];
    }
    const apiService = new ApiService();
    const response = await apiService.post<unknown>('/maintenance/table', {
        assets: assetIds.map(id => ({ id })),
    });
    if (response.status !== 200) {
        throw new Error(`Unexpected status ${response.status} from /maintenance/table`);
    }
    return extractList(response.data);
};
